import { render } from "./schedule-timings.vue?vue&type=template&id=b74ab22a"
import script from "./schedule-timings.vue?vue&type=script&lang=js"
export * from "./schedule-timings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__